import { ServiceFunctionsForm } from 'entities/settings/service-functions/service-functions.form';
import { NotificationsForm } from 'entities/settings/notifications/notifications.form';
import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { TabPanel } from 'shared/ui/tab-panel';
import { LeadSourcesSettings } from 'entities/settings/lead-sources/lead-sources';

export const ServiceFunctionsSettingsTab = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tab} onChange={(_, value) => setTab(value)}>
          <Tab label="Бухгалтерские настройки" />
          <Tab label="Почтовые уведомления" />
          <Tab label="Источники лидов" />
        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <ServiceFunctionsForm />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <NotificationsForm />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <LeadSourcesSettings />
      </TabPanel>
    </Box>
  );
};
